/**********************************************************************
// @@@ START COPYRIGHT @@@
//        AVI SOLAR ENERGY CONFIDENTIAL: NEED TO KNOW ONLY
//        Copyright 2018 - 2019
//        Avi Solar Energy Pvt Ltd.
//        Protected as an unpublished work.
//  The computer program listings, specifications and documentation
//  herein are the property of Avi Solar Energy Pvt Ltd., or a third party supplier
//  and shall not be reproduced, copied, disclosed, or used in whole or in part for
//  any reason without the prior express written permission of Avi Solar Energy Pvt Ltd.
// @@@ END COPYRIGHT @@@
// +++ Code modified on 2019/02/25
**********************************************************************/
import { Api } from '@/services/Api'

export default {
  controllableDeviceList (plantId) {
    return Api().get(`/api/v1.0/controlling/controllableDevices/${plantId}`)
  },
  controllableDeviceDetails(plantId) {
    return Api().get(`/api/v1.0/controlling/controllableDevices/status/${plantId}`)
  },
  insertDeviceStateChange(values) {
    return Api().post('/api/v1.0/controlling/controllableDevices/', values)
  },
  insertEventLog(values) {
    return Api().post('/api/v2/controlling/controllableDevices/', values)
  },
  fetchEventLog(plantId, type, timeFrom, timeTo) {
    return Api().get(`/api/v2/controlling/controllableDevices/log/${plantId}/${type}/${timeFrom}/${timeTo}`)
  },
  getV2VcbList(plantId) {
    return Api().get(`/api/v2/controlling/controllableDevices/vcb/${plantId}`)
  },
  getV2InverterList(plantId) {
    return Api().get(`/api/v2/controlling/controllableDevices/inverter/${plantId}`)
  },
  getInverterData(plantId) {
    return Api().get(`/api/v2/controlling/controllableDevices/data/inverter/${plantId}`)
  },
  getVcbList(plantId) {
    return Api().get(`/api/v1.0/controlling/controllableDevices/vcb/${plantId}`)
  },
  getRelayList(plantId) {
    return Api().get(`/api/v1.0/controlling/controllableDevices/relay/${plantId}`)
  },
  getVcbStatus(plantId) {
    return Api().get(`/api/v1.0/controlling/controllableDevices/vcbStatus/${plantId}`)
  },
  getVcbSwitchMode(plantId) {
    return Api().get(`/api/v2/controlling/controllableDevices/vcbMode/${plantId}`)
  }
}
